import SEO from '../components/SEO';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT = `
  <h2>Senior School Programme</h2>
  <p><em>Preparing for the Real-life</em></p>
  <p>The 21st century has turned into a competitive sprint. In the competitive space, we want our alumni to outshine and deliver the best. To achieve these results, Cambridge International Sr. Sec. School's Senior Programme focuses on in-depth learning along with the necessary on-field and integrated projects. The students have multiple channels to express their perspectives and assessments through assignments. The projects promote teamwork and creativity and instill leadership skills. Simultaneously, the faculty helps the students to build writing and examination skills.</p>
  <p>The teenage years can be confusing and overwhelming. But these are also the foundational years of your prospective career. Our Senior Programme ensures that young minds are trained to deal with the insecurities and issues we face in our daily lives. The Senior Programme curriculum motivates the students to be independent and understand the responsibility of learning. Our faculty opts for collaborative teaching where the students are constantly motivated and feel supported. We conduct regular workshops and sessions to help the students talk or feel comfortable about subjects that are considered 'taboo'.</p>
  <p>Our classrooms depict the creative and positive 'vibe' which is necessary for an optimistic mindset. The classrooms are also tech-equipped with all the necessary technology tools required to accelerate your learning journey. The students have constant e-learning support and our faculty introduces them to podcasts, e-groups, and interactive boards to have a better understanding of subjects.</p>
  <p>At Cambridge International Sr. Sec. School, the students get to explore their talents – be it in the science field or artistic. The talents of music, art, theatre, sports, or scientific progress are equally rewarded with regular competitions. We provide the required platform and international exposure that can swiftly help them reach a wider audience.</p>
`;

const SeniorSchoolProgrammePage = () => {
  const pageData = usePage('senior-school-programme', { content: DEFAULT_CONTENT });

  const title = 'Senior School Programme';

  return (
    <>
      <SEO title={title} description="Senior School Programme at Cambridge International Sr. Sec. School, Bhadana. Preparing for the Real-life." keywords="Senior School Programme, Cambridge International Sr. Sec. School" />

      <section className="page-hero">
        {!pageData.loading && <img src={pageData.bannerImage || '${process.env.PUBLIC_URL}/images/page-banners/admission-guidliness.jpg'} alt={title} className="page-hero-img" loading="eager" />}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner"></div>
          </div>
        </div>
      </section>

      <section className="content-page">
        <div className="container">
          <div className="card p-7 md:p-10 max-w-[1000px] mx-auto">
            <div className="text-body leading-relaxed space-y-5" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default SeniorSchoolProgrammePage;
